import { ShopUsersApiClient } from '@fourthwall/services/dist/ShopUsersApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUserUpdateMutation = createMutationHook(ShopUsersApiClient.updateUser, {
  mutationKey: ['userUpdate'],
})
